import axios from "axios";
import {Get, Delete, Put} from "../server";

// 查询所有用户信息
export const selectAllUserInfo = (params: any) => {
    return Get("/admin/user/users", params);
};

// 获取奖品信息
export const selectPrizeUserInfo = (params: any) => {
    return Get("/admin/prize", params);
};
// 查询用户信息
export const selectUserInfo = (userId: any) => {
    return Get(`/admin/user/profile/${userId}`);
};

// 查询用户钱包
export const selectUserMoney = (userId: any) => {
    return Get(`/admin/user/money/wallet/${userId}`);
};

// 查询Cash明细
export const selectUserGoldDetails = (userId: any, params: any) => {
    return Get(`/admin/user/money/goldDetails/${userId}`, params);
};

// 查询礼品积分明细
export const selectUserSilverDetails = (userId: any, params: any) => {
    return Get(`/admin/user/money/silverDetails/${userId}`, params);
};

// 查询用户好友
export const selectUserFriends = (userId: any, params: any) => {
    return Get(`/admin/user/friends/${userId}`, params);
};

export const selectUserBank = (userId: any) => {
    return Get(`/admin/user/profile/bankCard/${userId}`);
};

// 聊天记录
export const selectChantRecord = (params: any) => {
    return Get(`/admin/user/draws`, params);
};

// 群聊天记录
export const selectGroupChantRecord = (groupId: any, params: any) => {
    return Get(`/admin/group/messages/${groupId}`, params);
};

// 群聊
export const selectUserGroup = (userId: any, params: any) => {
    return Get(`/admin/user/groups/${userId}`, params);
};

// 下级信息
export const selectNextList = (userId: any, params: any) => {
    return Get(`/admin/user/invites/${userId}`, params);
};

// 群聊列表
export const selectGroupList = (params: any) => {
    return Get(`/admin/user/draws`, params);
};

// --------------
export const selectDrawList = (params: any) => {
    return Get(`/admin/user/draws`, params);
};

// 成员信息 /group/members/{groupId}
export const selectGroupManList = (groupId: any, params: any) => {
    return Get(`/admin/group/members/${groupId}`, params);
};

// 用户头像
export const getUserAvatar = (filename: any) => {
    return Get(`/admin/user/profile/avatar/${filename}`);
};

// 导出用户信息
export const exportUser = (params: any) => {
    return Get(`/admin/user/users/excel`, params, { responseType: "blob" });
};

// 导出用户好友信息
export const exportUserFriends = (list: any, userId: string) => {
    // return Get(`/user/friends/${userId}/excel`, list, { responseType: "blob" });
    return axios({
        url: `/admin/user/friends/${userId}/excel`,
        baseURL: process.env.REACT_APP_BASE_URL,
        responseType: "blob",
        method: "get",
        params: list,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
    });
};

// 导出用户好友信息
export const exportUserNext = (list: any, userId: string) => {
    // return Get(`/user/friends/${userId}/excel`, list, { responseType: "blob" });
    return axios({
        url: `/admin/user/invites/${userId}/excel`,
        baseURL: process.env.REACT_APP_BASE_URL,
        responseType: "blob",
        method: "get",
        params: list,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
    });
};

// 导出用户好友信息
export const exportUserGroups = (list: any, userId: string) => {
    // return Get(`/user/friends/${userId}/excel`, list, { responseType: "blob" });
    return axios({
        url: `/admin/user/groups/${userId}/excel`,
        baseURL: process.env.REACT_APP_BASE_URL,
        responseType: "blob",
        method: "get",
        params: list,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
    });
};

// 导出用户信息
export const exportGroup = (params: any) => {
    return Get(`/admin/group/groups/excel`, params, { responseType: "blob" });
};

// 更新角色状态，启用，停用
export function updateUserDetail(userId: any, data: any) {
    //Get方法用于向后台发送请求
    return axios({
        url: `/admin/user/profile/${userId}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

// 投诉记录
export const userReportConfig = (params: any) => {
    return Get("/admin/report/reports", params);
};

// 修改投诉状态
export const fixReportStatus = (reportId: any, data: any) => {
    return axios({
        url: `/admin/report/${reportId}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
};

// 朋友圈动态管理
export const circleOffrienesConfig = (params: any) => {
    return Get("/admin/post/posts", params);
};

// 修改用户余额
export const UpdateCoinFix = (reportId: any, data: any) => {
    return axios({
        url: `/admin/user/money/coin/${reportId}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
};

// 审核动态
export const auditTrends = (postId: any, params: any) => {
    return axios({
        url: `/admin/post/${postId}/audit`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

export const setCommercialOwner = (params: any) => {
    return axios({
        url: `/admin/biz/`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}


export const getBiz = (params: any) => {
    return Get('/admin/biz/', params)
}

export const updateBiz = (bizID: any, params: any) => {
    return axios({
        url: `/admin/biz/${bizID}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

export const getBizGoods = (params: any) => {
    return Get('/admin/bizGoods/', params)
}
export const getBizGoodsBiz = (bizId: any, params: any) => {
    return Get(`/admin/bizGoods/biz/${bizId}`, params)
}
export const updateBizGoods = (bizGoodsID: any, params: any) => {
    return axios({
        url: `/admin/bizGoods/${bizGoodsID}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}
export const postBizGoods = (params: any) => {
    return axios({
        url: `/admin/bizGoods/`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

export const postBizGoodsDetail = (params: any) => {
    return axios({
        url: `/admin/biz/goods`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

export const getBizTrade = (params: any) => {
    return Get('/admin/bizTrade/', params)
}

export const getBizSettle = (params: any) => {
    return Get('/admin/bizSettle/', params)
}
export const getBizSettleDetail = (bizGoodsID: any) => {
    return Get(`/admin/bizSettle/${bizGoodsID}`)
}

export const getBizSettleListDetail = ({ bizGoodsID, params }: any) => {
    return Get(`/admin/bizGoods/list/${bizGoodsID}`, params)
}
export const updataBizSettle = ({ id, params }: any) => {
    return axios({
        url: `/admin/bizSettle/${id}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}
export const getBizOrder = (bizGoodsID: any) => {
    return Get(`/admin/bizOrder/${bizGoodsID}`)
}

export const getBizOrderList = (params: any) => {
    return Get(`/admin/bizOrder/`, params)
}

export const giftCoinDetails = (id: any, params: any) => {
    return Get(`/admin/user/money/giftCoinDetails/${id}`, params)
}

export const getGiftCoinDetails = (params: any) => {
    return Get(`/admin/bill/giftCoinDetail/giftCoinDetails`, params)
}

export const deleteBizGoods = (bizGoodsID: any) => {
    return axios({
        url: `/admin/bizGoods/${bizGoodsID}`,
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}
export const deleteBatch = (data: any) => {
    return axios({
        url: `/admin/bizGoods/batch`,
        method: "delete",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

export const allowGiftCoin = ({ id, data }: any) => {
    return axios({
        url: `/admin/user/allowGiftCoin/${id}`,
        method: 'put',
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    })
}

export const getUserAblum = ({ id, params }: any) => {
    return Get(`/admin/album/${id}`, params)
}

export const getAlbumFile = ({ id, params }: any) => {
    return Get(`/admin/album/file/${id}`, params)
}

export const deleteAlbum = (id: string) => {
    const headers: any = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    }
    return Delete(`/admin/album/${id}`,
        headers,
        {})
}

export const deleteAlbumFile = (fileId: any) => {
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    }
    return Delete(`/admin/album/file/${fileId}`,
        headers,
        {})
}
export const getAllBizSales = (params?: any) => {
    return Get(`/admin/bizSales`, params)
}
// 更新商戶状态，启用，停用
export function updateMerchantDetail(data: any) {
    //Get方法用于向后台发送请求
    return axios({
        url: `/admin/biz/checkStatus`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}
export const getPermitAuditRecords = (params: any) => {
    return Get(`/admin/biz/permitAuditRecords`, params)
}
// 審核營業執照
export const upDataPermitAudit = (data: any) => {
    return axios({
        url: `/admin/biz/permitAudit`,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}



// 修改奖品
export const UpdatePrizeFix = (data: any) => {
    return axios({
        url: `/admin/user/cheat`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
};

// 获取当前数据
export const drawPeriodList = (params: any) => {
    return Get(`/admin/drawPeriod`, params)
}

// 获取当前数据
export const prizesyncList = () => {
    return Get(`/admin/prize/sync`)
}

export const getSystemStatus = () =>{
    return Get(`/admin/user/system/status`)
}

export const updateSystemStatus = (data) =>{
    return Put(`/admin/user/system/status`,{},data)
}
